import { PLAY_STORE_URL } from "../config/store";
import {
  COMPANY_NAME,
  DEFAULT_DESCRIPTION,
  getSiteUrl,
  LOGO_PATH,
  SAME_AS,
  SITE_NAME,
} from "../config/site";

export const organizationJsonLd = () => {
  const url = getSiteUrl();
  return {
    "@type": "Organization",
    "@id": `${url}/#organization`,
    name: COMPANY_NAME,
    url,
    logo: {
      "@type": "ImageObject",
      url: `${url}${LOGO_PATH}`,
    },
    sameAs: SAME_AS,
    address: {
      "@type": "PostalAddress",
      streetAddress: "H.No. 383, Muzaffarabad",
      addressLocality: "Saharanpur",
      addressRegion: "Uttar Pradesh",
      postalCode: "247129",
      addressCountry: "IN",
    },
  };
};

export const webSiteJsonLd = () => {
  const url = getSiteUrl();
  return {
    "@type": "WebSite",
    "@id": `${url}/#website`,
    name: SITE_NAME,
    url,
    inLanguage: "en-IN",
    description: DEFAULT_DESCRIPTION,
    publisher: { "@id": `${url}/#organization` },
  };
};

export const mobileApplicationJsonLd = () => ({
  "@type": "MobileApplication",
  name: SITE_NAME,
  applicationCategory: "FinanceApplication",
  operatingSystem: "Android",
  installUrl: PLAY_STORE_URL,
  downloadUrl: PLAY_STORE_URL,
  offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
  description:
    "Money-management app to track income and expenses, categorize spending, and view reports. Optional auction committee management.",
  publisher: { "@id": `${getSiteUrl()}/#organization` },
});

export const breadcrumbJsonLd = (pathname, pageTitle) => {
  const url = getSiteUrl();
  const path = pathname || "/";
  const items = [{ name: "Home", item: `${url}/` }];

  if (path !== "/") {
    if (path.startsWith("/blog/") && path !== "/blog") {
      items.push({ name: "Blog", item: `${url}/blog` });
    }
    items.push({
      name: pageTitle || path.replace(/^\//, ""),
      item: `${url}${path}`,
    });
  }

  return {
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.item,
    })),
  };
};

export const blogPostingJsonLd = (post) => {
  const url = getSiteUrl();
  const page = `${url}/blog/${post.slug}`;
  const image = `${url}${post.ogImage || post.image || post.cover || "/covers/treasure-16-9.jpg"}`;
  const keywords = [post.focusKeyword, ...(post.tags || [])].filter(Boolean);
  return {
    "@type": "BlogPosting",
    "@id": `${page}#article`,
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    dateModified: post.updated || post.date,
    wordCount: post.wordCount || undefined,
    articleSection: post.category || "Guide",
    keywords: keywords.join(", "),
    mainEntityOfPage: { "@type": "WebPage", "@id": page },
    inLanguage: "en-IN",
    author: {
      "@type": "Organization",
      name: COMPANY_NAME,
      url,
    },
    publisher: { "@id": `${url}/#organization` },
    image: {
      "@type": "ImageObject",
      url: image,
      width: 1280,
      height: 720,
    },
  };
};

export const faqPageJsonLd = (post) => {
  if (!post?.faqs?.length) return null;
  return {
    "@type": "FAQPage",
    mainEntity: post.faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };
};

export const blogItemListJsonLd = (posts) => {
  const url = getSiteUrl();
  return {
    "@type": "ItemList",
    name: "Treasure Blog",
    itemListElement: posts.map((post, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${url}/blog/${post.slug}`,
      name: post.title,
    })),
  };
};

export const siteGraphJsonLd = (pathname, pageTitle) => ({
  "@context": "https://schema.org",
  "@graph": [organizationJsonLd(), webSiteJsonLd(), breadcrumbJsonLd(pathname, pageTitle)],
});
